import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { leakCategories } from "@/mocks/leaks";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/leaks", label: "线索库" },
  { to: "/about", label: "关于本站" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-background-50/10 bg-foreground-950/95 backdrop-blur">
      <div className="wrap flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <span className="relative flex h-9 w-9 items-center justify-center rounded bg-primary-500 font-heading text-lg font-bold leading-none text-background-50">
            深
            <span className="lamp-pulse absolute -right-1 -top-1 h-2 w-2 rounded-full bg-accent-400" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-background-50">
              深夜爆料
            </span>
            <span className="font-label text-[10px] tracking-[0.28em] text-background-400">
              MIDNIGHT LEAKS
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? "bg-background-50/10 text-background-50"
                    : "text-background-300 hover:bg-background-50/10 hover:text-background-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          <div
            className="relative"
            onMouseEnter={() => setCatOpen(true)}
            onMouseLeave={() => setCatOpen(false)}
          >
            <button
              type="button"
              aria-expanded={catOpen}
              onClick={() => setCatOpen((v) => !v)}
              className="flex items-center gap-1 rounded-md px-4 py-2 font-label text-sm text-background-300 transition-colors hover:bg-background-50/10 hover:text-background-50 cursor-pointer"
            >
              线索分类
              <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? "rotate-180" : ""}`} />
            </button>
            {catOpen ? (
              <div className="absolute left-0 top-full w-64 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-2 shadow-none">
                {leakCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/leaks?cat=${cat.slug}`}
                    className="flex items-center justify-between px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                  >
                    <span>{cat.name}</span>
                    <span className="font-label text-[11px] text-foreground-400">{cat.count}</span>
                  </Link>
                ))}
              </div>
            ) : null}
          </div>
        </nav>

        <div className="hidden md:block">
          <Link
            to="/#submit"
            className="btn-base bg-primary-500 px-4 py-2 text-background-50 hover:bg-primary-600"
          >
            <i className="ri-mic-line text-base" />
            我要投稿
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-50/10 bg-foreground-950 md:hidden">
          <div className="wrap flex flex-col py-3">
            {navLinks.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 font-label text-sm ${
                    isActive ? "bg-background-50/10 text-background-50" : "text-background-300"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="mt-1 px-3 py-2 font-label text-[11px] tracking-[0.25em] text-background-500">
              线索分类
            </div>
            <div className="flex flex-wrap gap-2 px-3 pb-3">
              {leakCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/leaks?cat=${cat.slug}`}
                  className="rounded-full border border-background-50/15 px-3 py-1.5 font-label text-xs text-background-300"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link
              to="/#submit"
              className="btn-base mt-2 bg-primary-500 px-4 py-2.5 text-background-50"
            >
              <i className="ri-mic-line text-base" />
              我要投稿
            </Link>
          </div>
        </div>
      ) : null}
    </header>
  );
}